import { ZIndexBuilder } from '@ff/ui/utils/ZIndexBuilder';

export const zIndices = new ZIndexBuilder({
  floatingCta: {
    sectionNavigator: {
      lastSlide: { // last slide needs to be > 2 to be selectable in editor
        homePageCarousel: {
          base: {}
        }
      }
    }
  },
}).zIndices;
